import React from "react";
import { StyleSheet, View, TouchableOpacity, Image } from "react-native";
import { useSelector } from "react-redux";
import ProgressBar from "@screens/ClProfile/components/ProgressBar";
import LinearGradient from "react-native-linear-gradient";
import analytics from "@services/analytics";
import { CL_PROFILE_EVENTS } from "@constants/analyticsEventsCT";
import CustomText from "@components/CustomText";
import entityStyle from "@utils/entityStyle";

const CompleteClProfile = ({
  navigation,
  cl_title = "",
  cl_subtitle = "",
  text_ctx_cl = "",
}) => {
  const { clDropDownOptions = [], ...userDetails } = useSelector(
    ({ auth: { user } }) => user,
  );

  const navigateToCompleteProfile = () => {
    analytics.trackEvent(CL_PROFILE_EVENTS.COMPLETE_PROFILE_CTA, {
      source: "entity",
    });
    navigation.navigate("ClProfile", {
      source: "entity",
    });
  };

  const getInitialData = () => {
    let initialData = {};
    clDropDownOptions.forEach((el, i) => {
      initialData = Object.assign(initialData, {
        [el.name]: userDetails[el.name],
      });
    });
    return initialData;
  };

  const getItems = () => {
    const items = [];
    const initialdata = getInitialData();
    clDropDownOptions.map((option) => {
      if (option.is_skipable) return;
      if (initialdata[option.name] !== null) return;
      const method = "push";
      items[method](option);
      return null;
    });
    return items;
  };

  const totalItems = getItems();
  const totalItemsForPercent = clDropDownOptions.filter((elem) => {
    return !elem.is_skipable;
  });

  if (totalItems.length === 0) {
    return null;
  }

  return (
    <LinearGradient
      colors={["#2654B5", "#143374"]}
      start={{ x: 0.0, y: 0.1 }}
      end={{ x: 0.9, y: 0.4 }}
      style={[entityStyle.entityContainer, styles.card]}
    >
      <View style={styles.container}>
        <View style={styles.flex1}>
          <CustomText variant="body_text_2" style={styles.btn_heading1}>
            {cl_title}
          </CustomText>
          <CustomText variant="caption_2" style={styles.btn_heading}>
            {cl_subtitle}
          </CustomText>
          <ProgressBar
            containerStyle={{
              flexDirection: "column-reverse",
              alignItems: "flex-start",
            }}
            progressStyle={{
              backgroundColor: "white",
              width: "100%",
              flex: 0,
            }}
            textStyle={{
              color: "white",
              fontSize: 20,
              lineHeight: 22,
              marginTop: 12,
            }}
            totalItems={totalItemsForPercent.length}
            completed={totalItemsForPercent.length - totalItems.length}
          />
        </View>
        <View style={{ flex: 0.4 }} />
        <View>
          <Image
            style={{
              width: 92,
              height: 92,
              alignSelf: "flex-end",
            }}
            source={{
              uri: "https://pub-storage-svc.citymall.live/1622752629807image%201.webp",
            }}
          />
          <TouchableOpacity
            testID="cclp-button"
            onPress={navigateToCompleteProfile}
            style={styles.button}
          >
            <CustomText variant="body_text_2" style={styles.btn_text}>
              {text_ctx_cl}
            </CustomText>
          </TouchableOpacity>
        </View>
      </View>
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  card: {
    paddingHorizontal: 12,
    paddingVertical: 16,
    backgroundColor: "white",
    borderRadius: 6,
  },
  container: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  flex1: {
    flex: 1,
  },
  button: {
    alignItems: "center",
    backgroundColor: "#E40046",
    paddingHorizontal: 14,
    paddingVertical: 9,
    borderRadius: 6,
    marginTop: -18,
    marginLeft: -40,
    marginRight: 20,
  },
  btn_heading1: {
    color: "#fff",
    fontSize: 14,
    lineHeight: 20,
    fontWeight: "bold",
    marginBottom: 4,
  },
  btn_heading: {
    color: "#fff",
    fontSize: 12,
    lineHeight: 18,
  },
  btn_text: {
    color: "white",
    fontSize: 14,
    lineHeight: 18,
    fontWeight: "bold",
  },
});

export default CompleteClProfile;
